module.exports = __webpack_public_path__ + "static/media/robot-head.a4931aed.svg";